import { fragment } from '@atlaskit/adf-schema';
import { createPlugin as createFragmentMarkConsistencyPlugin } from './pm-plugins/fragment-consistency';
export var fragmentPlugin = function fragmentPlugin() {
  return {
    name: 'fragmentPlugin',
    marks: function marks() {
      return [{
        name: 'fragment',
        mark: fragment
      }];
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'fragmentMarkConsistency',
        plugin: function plugin(_ref) {
          var dispatch = _ref.dispatch;
          return createFragmentMarkConsistencyPlugin(dispatch);
        }
      }];
    }
  };
};